import { render } from "./ModalCreaPresenza.vue?vue&type=template&id=4e30ac5f&scoped=true"
import script from "./ModalCreaPresenza.vue?vue&type=script&lang=js"
export * from "./ModalCreaPresenza.vue?vue&type=script&lang=js"

import "./ModalCreaPresenza.vue?vue&type=style&index=0&id=4e30ac5f&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_confcooperative/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e30ac5f"]])

export default __exports__